module.exports = __webpack_public_path__ + "static/media/Shitij Agrawal.d597041b.jpg";